import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { conversationService } from '../../services/api';

const EventInternalRemark = ({
  event,
  onUpdate,
  className = ""
}) => {
  const { t } = useLanguage();
  const [isEditing, setIsEditing] = useState(false);
  const [remark, setRemark] = useState(event.meta_data?.internal_remark || '');
  const [isSaving, setIsSaving] = useState(false);

  const getInternalRemark = (event) => {
    return event.meta_data?.internal_remark || '';
  };

  const handleEdit = () => {
    setIsEditing(true);
    setRemark(getInternalRemark(event));
  };

  const handleCancel = () => {
    setIsEditing(false);
    setRemark(getInternalRemark(event));
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      await conversationService.setEventMetadata(event.id, 'internal_remark', remark);
      
      // Call the onUpdate callback to refresh the event data
      if (onUpdate) {
        await onUpdate();
      }
      
      setIsEditing(false);
    } catch (error) {
      console.error('Error saving internal remark:', error);
      // You could add a toast notification here
    } finally {
      setIsSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  if (isEditing) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <input
          type="text"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t('conversationActivities.internalRemarkPlaceholder')}
          className="flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          autoFocus
        />
        <button
          onClick={handleSave}
          disabled={isSaving}
          className="inline-flex items-center px-2 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSaving ? (
            <>
              <svg className="animate-spin -ml-1 mr-1 h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {t('conversationActivities.saving')}
            </>
          ) : (
            t('conversationActivities.save')
          )}
        </button>
        <button
          onClick={handleCancel}
          disabled={isSaving}
          className="inline-flex items-center px-2 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {t('conversationActivities.cancel')}
        </button>
      </div>
    );
  }

  const currentRemark = getInternalRemark(event);

  if (currentRemark) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <span className="text-sm text-gray-700 max-w-xs truncate" title={currentRemark}>
          {currentRemark}
        </span>
        <button
          onClick={handleEdit}
          className="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-600 hover:text-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded"
          title={t('conversationActivities.editInternalRemark')}
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={handleEdit}
      className={`inline-flex items-center px-2 py-1 text-xs font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-1 rounded border border-gray-300 ${className}`}
      title={t('conversationActivities.addInternalRemark')}
    >
      <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
      </svg>
      {t('conversationActivities.addInternalRemark')}
    </button>
  );
};

export default EventInternalRemark;

